<template>
  <div id="logoSalon" class="ion-text-center ion-margin">
    <!-- <img src="@/assets/salon-logo-horizontal.svg" alt="Logo Salon de la formation"> -->
    <img src="@/assets/logo-salon-metier-2026.svg" alt="Logo Salon de la formation">
  </div>
</template>

<script>
export default {
  name: 'LogoSalon'
}
</script>

<style scoped>
  #logoSalon img {
    height: 120px !important;
    text-align: right !important;
    margin: 0 !important;
  }

  #logoSalon div {
    margin: 0 !important;
    padding: 0 !important;
  }
</style>
